import axios from "src/lib/axios";
import AlertMessage from "src/components/ui-components/AlertMessage";

const API_URLS = {
  GET_Password_Policy: `/Password/GetPasswordPolicyList`,
  INSERT_UPDATE_PasswordPolicy: '/Password/InsertUpdatePasswordPolicy',
  GET_Password_Policy_Message: `/Password/GetPasswordPoliciesForInvitationModel`,
  GET_Password_Policy_Param: `/Password/GetPasswordPolicy`
};
type passPolicyMsg = {
  specialCharacterCricteriaMessage: string;
};
type pPolicyParam = {
  passwordPolicyKey?: string | null;
  minPasswordLength?: string;
  maxPasswordLength?: string;
  minDigitCount?: string | null;
  minUpperCaseCharCount?: string;
  minLowerCaseCharCount?: string;
  minSpecialCharCount?: string;
  allowedSpecialChars?: string;
  maxInvalidAttempts?: string;
};
type passPolicy = {
  passwordPolicyKey?: string | null;
  appKey?: string;
  minPasswordLength: Number;
  maxPasswordLength?: Number;
  minDigitCount?: Number | null;
  minUpperCaseCharCount: Number;
  minLowerCaseCharCount: Number;
  minSpecialCharCount: Number;
  allowedSpecialChars: Number;
  maxInvalidAttempts: Number;
  SpecialCharacterCricteriaMessage: string;
};
export const GetpasswordPolicies = async () => {
  const passwordPolicies = await axios.get<passPolicy>(API_URLS.GET_Password_Policy, {
  });
  return passwordPolicies?.data || {};
};
export const GetpasswordPolicyMessages = async (appkey, langCode) => {
  const passwordPolicies = await axios.get<passPolicyMsg>(API_URLS.GET_Password_Policy_Message, {
    params: {
      appkey,
      langCode
    }
  });
  return passwordPolicies?.data || {};
};
export const GetpasswordPolicyParameter = async (appkey) => {
  const passwordPolicies = await axios.get<pPolicyParam>(API_URLS.GET_Password_Policy_Param, {
    params: {
      appkey
    }
  });
  return passwordPolicies?.data || {};
};
export const InsUpdPasswordPolicy = async (passPolicy: any) => {
  try {
    const response = await axios.post(API_URLS.INSERT_UPDATE_PasswordPolicy, passPolicy);
    AlertMessage({ type: 'success', msg: response.data.message });
    return true;
  } catch (err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};